import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CheckDateValidityPipe } from 'src/app/shared/pipe/check-date-validity.pipe';

@Component({
  selector: 'app-activity-challenge-card',
  templateUrl: './activity-challenge-card.component.html',
  styleUrls: ['./activity-challenge-card.component.scss']
})
export class ActivityChallengeCardComponent {
  @Input() challenge: any;
  @Input() challengeFlag: any;
  @Input() isCiscoAdmin: boolean = false;
  @Input() userProfile: any;

  @Output() openDrawerClick = new EventEmitter<any>();
  @Output() openTermsClick = new EventEmitter<any>();
  @Output() editClick = new EventEmitter<any>();
  @Output() deleteClick = new EventEmitter<any>();
  @Output() cloneClick = new EventEmitter<any>();
  @Output() launchClick = new EventEmitter<any>();
  @Output() progressClick = new EventEmitter<any>();
  @Output() uploadDocClick = new EventEmitter<any>();
  @Output() claimsClick = new EventEmitter<void>();

  statusValue = '';

  private months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(private sanitizer: DomSanitizer) {}

  getChallengeStatus(challenge: any): string {
    if (challenge.completedOn) { return 'completed'; }
    const status = this.getStatus(challenge.completedOn, challenge.completeBy, challenge.createdOn, challenge.startDate);
    if (status === 'Closed') { return 'closed'; }
    if (status === 'Pending') { return 'pending'; }
    return 'open';
  }

  getCourseCompletedCount(challenge: any): number {
    return (challenge.coursesInfo || []).filter((c: any) => c.completedStatus).length;
  }

  getCourseProgressPercent(challenge: any): number {
    const total = (challenge.coursesInfo || []).length;
    if (!total) { return 0; }
    return Math.round(this.getCourseCompletedCount(challenge) / total * 100);
  }

  getStatus(check: any, completedBy: string, creationDate: string, startDate: string): string {
    const lang = localStorage.getItem('selectedLanguage');
    let value = '';
    this.statusValue = '';
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else if (lang == 'English') {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    this.statusValue = value;
    return value;
  }

  setTime(date: any): Date {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: string): string {
    const month = Number(date.substring(5, 7).replace(/^0+/, ''));
    const day = date.substring(8, 10).replace(/^0+/, '');
    const year = date.substring(0, 4);
    return `${this.months[month - 1]} ${day}, ${year}`;
  }

  checkDateValidity(challenge: any) {
    const td = new Date();
    return CheckDateValidityPipe.prototype.transform(
      challenge.startDate.substring(0, 10),
      challenge.completeBy.substring(0, 10),
      td.getFullYear() + '-' + Number(td.getMonth() + 1) + '-' + td.getDate()
    );
  }

  htmlProperty(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
